<template>
  <artmisads-modal
    :open="open"
    :title="t('seller.accBonusProgram.publishersTitle')"
    :width="720"
    :maskClosable="false"
    :footer="null"
    :onCancel="() => (open = false)"
    :destroyOnClose="true"
  >
    <artmisads-table
      v-model:pagination="pagination"
      :columns="columns"
      :data-source="dataSource"
      :change="onTableChange"
      :loading="load"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'publisher'">
          <div class="publisher-cell">
            <LogoImage :logoUrl="record.avatarUrl" :brandName="record.publisherName" />
            <span class="publisher-name">{{ record.publisherName }}</span>
          </div>
        </template>
        <template v-if="column.key === 'salesAmount' || column.key === 'bonusAmount'">
          {{ currencySymbol }} {{ formatAmount(record[column.key]) }}
        </template>
      </template>
    </artmisads-table>
  </artmisads-modal>
</template>

<script setup>
import { ref, reactive, computed, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n';
import LogoImage from '@/components/LogoImage.vue';
import { accBonusProgramApi } from '@/server/index';
import { CURRENCY_DATA_MAPPER } from '@/contants/common';


const { t } = useI18n();
const open = ref(false);
const load = ref(false);
const dataSource = ref([]);
const programId = ref('');
const currencyCode = ref('USD');

const currencySymbol = computed(() => CURRENCY_DATA_MAPPER[currencyCode.value] || '$');

const pagination = reactive({
  total: 0,
  current: 1,
  size: 10,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50'],
});

const columns = computed(() => [
  {
    title: t('seller.menu.publisher'),
    dataIndex: 'publisher',
    key: 'publisher',
    width: 220,
  },
  {
    title: t('seller.sellerAccount.colSales'),
    dataIndex: 'salesAmount',
    key: 'salesAmount',
  },
  {
    title: t('seller.accBonusProgram.colBonusEarned'),
    dataIndex: 'bonusAmount',
    key: 'bonusAmount',
  },
]);

const formatAmount = (val) => Number(val || 0).toFixed(2);

const onTableChange = ({ current, pageSize }) => {
  pagination.current = current;
  pagination.size = pageSize;
  pagination.pageSize = pageSize;
  fetchList();
};

const fetchList = async () => {
  if (!programId.value) return;
  load.value = true;
  try {
    const res = await accBonusProgramApi.getProgramPublisherDetail({
      programId: programId.value,
      page: pagination.current,
      size: pagination.size,
    });
    if (res?.success && res?.data) {
      const list = res.data.data ?? res.data;
      dataSource.value = list;
      pagination.total = res.data.total ?? list.length;
    } 
  } catch {
    
  } finally {
    load.value = false;
  }
};

const show = (row) => {
  programId.value = row.programId;
  currencyCode.value = row.currency || 'USD';
  pagination.current = 1;
  open.value = true;
  fetchList();
};

defineExpose({ show });
</script>

<style lang="less" scoped>
.publisher-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}
.publisher-name {
  font-size: 14px;
  color: #0f0629;
}
</style>
